import comp from "./ConfigureColumns";
export default comp;
